import React, {Component} from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {Link} from 'react-router-dom';

//import img
import chevronDown from '../../assets/icons/chevron-down.svg';
import chevronUp from '../../assets/icons/chevron-up.svg';

class StructureFoldersItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpened: true
        };
    };

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    toggleOpened = () => {
        const {width} = this.state;
        if (width < 800) {
            this.setState({isOpened: !this.state.isOpened });
        }
    };

    updateDimensions = () => {
        const updateWidth  = window.innerWidth;
        this.setState({ width: updateWidth });
    }

    render() {
        const { clang, type, title, img, desc, itemType } = this.props;
        const {isOpened, width } = this.state;
        const typeClass = type === 'records' ? 'paperclip' : '';

        return (
              <li className={`structure__folders-item ${typeClass} ${isOpened ? "opened" : "hidden"}`}>
                {title &&
                    <h5 className={`structure__folders-item__title ${typeClass}`} dangerouslySetInnerHTML={{__html:title}}></h5>}

                {img && img.length && img.map((img, imgIndex) =>
                    <figure className="structure__folders-item__img" key={imgIndex}>
                        <img src={img} className="structure__folders-item__img-icon" alt={lang[clang].alt.folder} />
                    </figure>)}

                {(width > 800 || (!isOpened && width < 801)) &&
                    <p className="structure__folders-item__desc">{desc}</p>}

                {width <= 800 &&
                    <button className="structure__folders-item__toggle" onClick={() => this.toggleOpened()}>
                        {isOpened && <span>{lang[clang].characteristics.show_description}</span>}
                        {!isOpened && <span>{lang[clang].characteristics.hide_description}</span>}
                        {isOpened && <img className="structure__folders-item__toggle-img" src={chevronDown} alt="" />}
                        {!isOpened && <img className="structure__folders-item__toggle-img" src={chevronUp} alt="" />}
                    </button>}

                <Link
                    to={`${type === 'files' ? `/files/search?q=*&area=${itemType}` : `/records/search?q=*&area=records&tab=records&RECORD_FORM[0]=${itemType}`}`}
                    className="structure__folders-item__btn"
                    title={type === 'files'? lang[clang].characteristics.go_to_file : lang[clang].characteristics.go_to_record}>

                    {type === 'files'? lang[clang].characteristics.go_to_file : lang[clang].characteristics.go_to_record}
                    <span className="structure__folders-item__btn-img"></span>
                </Link>
              </li>
        );
    };
};

StructureFoldersItem.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(StructureFoldersItem);



// WEBPACK FOOTER //
// ./src/components/characteristics/StructureFoldersItem.js